/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import {
  DbPersistenceService,
  Query
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppConfig } from 'src/app/app.config';
import { Car } from 'src/app/_model/car';
import { CarsDaoService } from '../cars-dao.service';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { CarDbTableDefinition } from './car-db-table-definition';

@Injectable()
export class CarsDbDaoService implements CarsDaoService {

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private appParameter: AppParameterService,
    private carTableDefinition: CarDbTableDefinition,
  ) { }

  public async saveCars(cars: Car[]): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();

      var carsQueries: Query[] = [];
      for (const car of cars) {
        let carQuery: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
             this.carTableDefinition.tableName +
            '(id, label, databag)' + // 3
            ' VALUES (?,?,?)',
          parameters: [
            Number(car.isLocal() ? car.id.secondaryId : car.id.imsId),
            car.label,
            car.databag ? JSON.stringify(car.databag) : undefined
          ]
        };
        carsQueries.push(carQuery);
      }
      await this.dbPersistenceService.executeBatch(db, carsQueries);
    } catch (error) {
      this.logger.log(
        'Error saving cars to db',
        error,
        '-',
        error.message
      );
    }
  }

  public async getCars(): Promise<Car[]> {
    let db = await this.dbPersistenceService.getImsDb();
    let cars: Car[] = [];

    try {
      // Get Synced Cars
      let data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.carTableDefinition.tableName + ';',
        parameters: null
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        cars.push(
          Car.fromDto({
            id: row['id'],
            secondaryid: undefined,
            label: row['label']
          }, row['databag'] ? JSON.parse(row['databag']): undefined, 
          this.appParameter.getFormatLabelForObject('ims/Car'))
        );
      }
    } catch (error) {
      this.logger.log('Error reading cars from db', error);
    }
    
    return cars;
  }

  public async reset() {
  }

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(this.constructor.name, "truncate table", this.carTableDefinition.tableName)
    await this.dbPersistenceService.truncateTable(db, this.carTableDefinition.tableName);
  }

}
